import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommon} from "../../shared/dto/aps.common";
import * as angular from "angular";
import * as _ from "lodash";
import NavigationPlantsServiceName, {NavigationPlantsService} from "./navigationPlants.service";
import AuthDataServiceName, {AuthDataService, RoleLocation} from "../auth/authData.service";
import NavigationModelName, {NavigationCtor, NavigationModel, Plant} from "../../models/navigation";
let requires = [NavigationPlantsServiceName, AuthDataServiceName, NavigationModelName];

export interface NavigationService {
  getNavigation(): angular.IPromise<NavigationModel>;
  getPlants(includeDeleted: boolean): angular.IPromise<Plant[]>;
  getLocations(includeDeleted: boolean): angular.IPromise<apsViewModels.LocationNavigation[]>;
  getCurrentRole(): apsCommon.UserRolePlants;
  setCurrentRole(role: apsCommon.UserRolePlants): void;
  clearSetRole(): void;
}

class NavigationServiceImpl implements NavigationService {
  private model: NavigationModel;
  private defer: angular.IDeferred<NavigationModel>;
  private $q: angular.IQService;
  private navigationPlantsService: NavigationPlantsService;
  private authDataService: AuthDataService;
/* tslint:disable:variable-name */
  private Navigation: NavigationCtor;
/* tslint:enable:variable-name */
  private setRole: apsCommon.UserRolePlants;

  constructor($q: angular.IQService,
              navigationPlantsService: NavigationPlantsService,
              /* tslint:disable:variable-name */
              Navigation: NavigationCtor,
              /* tslint:enable:variable-name */
              authDataService: AuthDataService) {
    this.$q = $q;
    this.navigationPlantsService = navigationPlantsService;
    this.Navigation = Navigation;
    this.authDataService = authDataService;
  }

  private getSelectedRoleLocation(): RoleLocation {
    return this.authDataService.getSelectedRoleLocation();
  }

  getNavigation(): angular.IPromise<NavigationModel> {
    return this.getDefer().promise;
  }

  getLocations(includeDeleted: boolean): angular.IPromise<apsViewModels.LocationNavigation[]> {
    return this.navigationPlantsService.getLocationNavigation(includeDeleted);
  }

  getPlants(includeDeleted: boolean): angular.IPromise<Plant[]> {
    var defer = this.$q.defer<Plant[]>();
    this.navigationPlantsService.getPlantNavigation(includeDeleted)
      .then((plants) => {
        defer.resolve(_.map(plants, p => {
          var plant = _.assign<Plant>({}, p);
          plant.shops = _.flatten<apsViewModels.ShopNavigation>(_.map(p.tanks, 'shops'));
          return plant;
        }));
      }, (error) => defer.reject(error));
    return defer.promise;
  }

  getCurrentRole(): apsCommon.UserRolePlants {
    var selected = this.getSelectedRoleLocation();
    if (selected) {
      return selected.role;
    }
    return this.setRole;
  }

  setCurrentRole(role: apsCommon.UserRolePlants): void {
    if (this.getCurrentRole() !== role) {
      this.setRole = role;
      if (this.defer) {
        this.getNavigation().then(model => model.roleChanged());
      }
    }
  }

  clearSetRole(): void {
    this.setRole = undefined;
  }

  private getDefer(): angular.IDeferred<NavigationModel> {
    if (this.defer) {
      return this.defer;
    }
    this.defer = this.$q.defer<NavigationModel>();
    this.navigationPlantsService.getPlantNavigation(false)
      .then((plants) => {
        this.model = new this.Navigation(plants, () => this.getCurrentRole());
        var selectedRoleLocation = this.getSelectedRoleLocation();
        if (selectedRoleLocation && selectedRoleLocation.plant) {
          var plant = _.find(this.model.plants(), {id: selectedRoleLocation.plant.id});
          if (plant) {
              this.model.selectedPlant = plant;
          }
        }

        if (selectedRoleLocation && selectedRoleLocation.shop) {
          var shop = _.find(this.model.shops(), {id: selectedRoleLocation.shop.id});
          if (shop) {
              this.model.selectedShop = shop;
          }
        }
        if (!this.model.selectedShop) {
          this.model.selectedShop = _.first(this.model.shops());
        }

        this.defer.resolve(this.model);
      }, (error) => {
        this.defer.reject(error);
        this.defer = undefined;
      });
    return this.defer;
  }
}

export default angular.module('aps.services.navigation', requires)
  .service('navigationService', NavigationServiceImpl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/navigation/navigation.service.ts